import React, { useEffect, useState } from "react";
import { useTranslation, Trans } from "react-i18next";
import { fetchReferralAmount } from "../api/referralApi";
import underlineimage from "../assets/images/title-shape.png";
import friendinvite from "../assets/images/reff.png";
import frnbbg from "../assets/images/gaming-stats-bg.png";
import RoundLoader from "../common/RoundLoader";

interface ReferralData {
  inviteAmount: string;
  referAmount: string;
}

const BrandIntegration: React.FC = () => {
  const { t } = useTranslation();
  const [inviteAmt, setInviteAmt] = useState<number>(0);
  const [refAmt, setRefAmt] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const getReferralAmounts = async () => {
      const data: ReferralData | null = await fetchReferralAmount();
      if (data) {
        setInviteAmt(parseInt(data.inviteAmount));
        setRefAmt(parseInt(data.referAmount));
      }
      setLoading(false);
    };
    getReferralAmounts();
  }, []);

  if (loading) {
    return (
      <div className="py-20 bg-[#070b28] text-center">
        <RoundLoader size={8} color="#f92c2c" borderWidth={5} />
      </div>
    );
  }

  return (
    <div
      className="text-center pt-16 px-4 overflow-hidden"
      style={{
        backgroundImage: `url(${frnbbg})`,
        backgroundColor: "#070b28",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        backgroundPosition: "bottom 15px center",
        paddingBottom: "100px",
      }}
    >
      <h2 className="text-[36px] md:text-[48px] font-oswald font-extrabold text-white">

        {t("brandint")}
      </h2>

      <img
        src={underlineimage}
        alt="underline"
        className="mx-auto mt-2 mb-4 w-[120px] h-auto"
      />

      {/* <p className="text-[16px] md:text-[18px] font-medium font-proxima max-w-xl mx-auto mb-12 text-white">
        {t("referral.subtitle")}
      </p> */}

      <div className="flex flex-col md:flex-row items-center justify-center gap-[6rem] md:gap-12 px-4 md:px-12">
        {/* Right Section */}
        {/* <div className="text-white text-left max-w-lg">
          <p className="text-[25px] text-[#ffffff] font-semibold font-proxima mb-5">
            <Trans
              i18nKey="referral.message"
              values={{ inviteAmt, refAmt }}
              components={{
                coin: (
                  <img
                    src={coinIcon}
                    alt="coin"
                    className="w-5 h-5 inline-block"
                  />
                ),
              }}
            />
          </p>

          <a
            href="https://play.google.com/store/apps/details?id=com.gamerji.sportsdraft"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 bg-[#070b28] text-white py-3 px-6 rounded-lg hover:bg-[#222] transition-all border border-white/20 w-[50%]"
          >
            <i className="fa fa-android fa-2x text-white mr-[2px]"></i>
            <div className="text-left font-proxima leading-none">
              <p className="text-xs font-medium">{t("referral.downloadText")}</p>
              <p className="text-base font-bold">{t("referral.androidApp")}</p>
            </div>
          </a>
        </div> */}
        <div className="text-white text-left max-w-lg">
          <p className="text-[18px] md:text-[22px] font-proxima font-semibold text-[#ffffff] max-w-xl mx-auto md:mx-0">
            {t("platforwaiting")}
          </p>
        </div>
        {/* Left Image */}
        <div className="w-[430px] h-[450px] rounded-full flex items-center justify-center overflow-hidden">
          <img
            src={friendinvite}
            alt="Invite a Friend"
            className="object-contain w-full h-full"
          />
        </div>
      </div>
    </div>
  );
};

export default BrandIntegration;